import React from 'react';
import { Flame, Wind, Snowflake, Droplets, Zap } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { services } from '../data/mock';

const iconMap = {
  Flame: Flame,
  Wind: Wind,
  Snowflake: Snowflake,
  Droplets: Droplets,
  Zap: Zap
};

export const Services = () => {
  return (
    <section id="leistungen" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-orange-500 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Unsere Leistungen
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Umfassende Gebäudetechnik
            <span className="block text-slate-700">aus einer Hand</span>
          </h2>
          <p className="text-lg text-gray-600">
            Als Generalunternehmer bieten wir Ihnen das komplette Spektrum moderner
            Gebäudetechnik für Wohn- und Gewerbeimmobilien.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-orange-400 overflow-hidden"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 to-transparent"></div>
                  {/* Icon Badge */}
                  <div className="absolute bottom-4 left-4 w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="text-white" size={24} />
                  </div>
                </div>

                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-orange-500 transition-colors duration-200">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};